
import {defineComponent} from 'vue';

const payoutFormatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });

export default defineComponent({
	name: 'EventPayouts',
	props: {
		events: {
			default: () => [],
		},
	},
	computed: {
		paidEvents() {
			return (this.events ?? []).filter((e) => e.payout_mode !== 'NONE');
		},
	},
	methods: {
		formatPayout(e) {
			// rev share comes as a fraction: 0.7 -> 70%
			if (e.payout_mode === 'REV_SHARE') return `RevShare ${payoutFormatter.format(e.payout_value * 100)}%`;
			return new Intl.NumberFormat('en-US', { style: 'currency', currency: e.currency, maximumFractionDigits: 3 }).format(e.payout_value);
		},
	},
});
